import SalesBudgetYearLayout from './salesBudgetYearLayout';

export default SalesBudgetYearLayout;
